// Footer.tsx
import * as React from "react";
import { Container, Typography, Link, Box } from "@mui/material";

const ACCENT = "#d4163c";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#000",
        borderTop: "1px solid " + ACCENT,
        py: 4,
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 3,
            mb: 2,
            fontSize: 13,
          }}
        >
          <Link href="/contact" sx={{ color: "#bbb", textDecoration: "none" }}>
            Contact
          </Link>
        </Box>
        <Typography variant="body2" sx={{ color: "#bbb", mb: 1 }}>
          <Box component="span" sx={{ fontWeight: "bold", mr: 1 }}>
            Contact Us:
          </Box>
          <Link
            href="mailto:contact@besteurogirls.com"
            sx={{ color: ACCENT, textDecoration: "none" }}
          >
            contact@besteurogirls.com
          </Link>
        </Typography>
        <Typography variant="body2" sx={{ color: "#777", fontSize: 12 }}>
          © {new Date().getFullYear()}{" "}
          <Link
            href="https://besteurogirls.com/"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            BestEuroGirls.com
          </Link>
          . All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export { Footer };
